import { Stack } from "@mui/material";
import { Switch } from "features/shared/components/Switch";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useTabs } from "../../hooks/components";
import { SecondaryTabs } from "./SecondaryTabs";

export const RetrofitsFinancialChartTabsWrapper = ({
  isPartitions,
  isYearly,
  setActiveTabName,
  setIsPartitions,
  setIsYearly,
}) => {
  const { t } = useTranslation();
  const tabs = useMemo(
    () => [
      { displayName: t("Modernization.wizard.totalCostsVsSavings"), name: "totals" },
      { displayName: t("Modernization.wizard.cashflow"), name: "cashflow" },
    ],
    [t]
  );
  const { activeTab, handleTabChange } = useTabs(tabs, tabs[0]);

  useEffect(() => {
    setActiveTabName?.(activeTab?.name ?? "totals");
  }, [activeTab, setActiveTabName]);

  return (
    <div className="mb-2 mt-6 flex items-center justify-between gap-2">
      <SecondaryTabs activeTab={activeTab} handleTabChange={handleTabChange} tabs={tabs} />
      {activeTab?.name === "totals" && (
        <Stack direction="row">
          <Switch checked={isYearly} label={t("Modernization.wizard.yearly")} onChange={setIsYearly} />
          <Switch checked={isPartitions} label={t("Modernization.wizard.partitions")} onChange={setIsPartitions} />
        </Stack>
      )}
    </div>
  );
};
